import { render, staticRenderFns } from "./BacPrefixedInput.vue?vue&type=template&id=3d5144ea&scoped=true&"
import script from "./BacPrefixedInput.vue?vue&type=script&lang=ts&"
export * from "./BacPrefixedInput.vue?vue&type=script&lang=ts&"
import style0 from "./BacPrefixedInput.vue?vue&type=style&index=0&id=3d5144ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5144ea",
  null
  
)

export default component.exports